<template>
  <a-drawer
    title="修改收货地地址"
    placement="right"
    :visible="visible"
    width="640px"
    class="edit-address"
    @close="onClose"
  >
    <a-alert
      message="同一个订单只允许申请一次收货地变更，请仔细核对信息"
      banner
      class="address-alert"
    />
    <p class="order-no">
      订单号 {{editRow.odrNo}}
    </p>
    <div v-if="isChange" class="status">
      <div :class="`dot ${editRow.flowStatus}`" />
      {{FLOWSTATUS[editRow.flowStatus]}}
    </div>
    <a-form-model
      ref="addressForm"
      :model="form"
      :colon="false"
      :rules="rules"
      :hide-required-mark="true"
    >
      <block-title
        title="站点修改信息"
        :show-line="false"
      >
        <div class="info-block">
          <div class="change-title change-before">变更前</div>
          <div class="flex change-info">
            <div>
              <p class="info-title">地址</p>
              <p class="info-value">
                {{(editRow.originalProvinceName)}}
                {{editRow.originalCityName}}
                {{editRow.originalCountyName}}
                {{editRow.originalStationAddress}}
              </p>
            </div>
            <div>
              <p class="info-title">联系人</p>
              <p class="info-value">
                {{editRow.originalStationContact}}
                {{editRow.originalStationContactPhone}}
              </p>
            </div>
          </div>
        </div>
        <div class="info-block">
          <div class="change-title change-after">变更后</div>
            <template v-if="isChange">
              <div class="flex change-info">
                <div>
                  <p class="info-title">地址</p>
                  <p class="info-value">
                    {{editRow.provinceName}}
                    {{editRow.cityName}}
                    {{editRow.countyName}}
                    {{editRow.address}}
                  </p>
                </div>
                <div>
                  <p class="info-title">联系人</p>
                  <p class="info-value">
                    {{editRow.stationContact}}
                    {{editRow.stationContactPhone}}
                  </p>
                </div>
              </div>
              <div class="flex change-info">
                <div>
                  <p class="info-title">变更方式</p>
                  <p class="info-value">
                    {{CHANGETYPE[editRow.type]}}
                  </p>
                </div>
                <div>
                  <p class="info-title">变更原因</p>
                  <p class="info-value">
                    {{editRow.reason}}
                  </p>
                </div>
              </div>
            </template>
            <template v-else>
              <el-row>
              <a-form-model-item label="地址" prop="allAdress">
                <a-select
                  v-model="form.allAdress"
                  placeholder="请输入变更后地址信息"
                  show-search
                  :get-popup-container="node=>node.parentNode"
                  :filter-option="false"
                  :not-found-content="loading.onPoiSearch ? undefined : null"
                  @search="onPoiSearch"
                  @change="handlePoiChange"
                >
                  <a-spin v-if="loading.onPoiSearch" slot="notFoundContent" size="small" />
                  <a-select-option
                    v-for="item in poiList"
                    :key="item.id"
                  >
                    {{ `${item.province || ''}${item.city || ''}${item.county ||''}${item.origAddress||''}` }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </el-row>
            <el-row>
              <el-col :span="11">
                <a-form-model-item label="联系人姓名" prop="stationContact">
                  <a-input v-model="form.stationContact" :max-length="10" placeholder="请输入联系人姓名" />
                </a-form-model-item>
              </el-col>
              <el-col :span="11" :offset="2">
                <a-form-model-item label="联系人手机号" prop="stationContactPhone">
                  <a-input v-model="form.stationContactPhone" :max-length="12" placeholder="请输入联系人手机号" />
                </a-form-model-item>
              </el-col>
            </el-row>
            <el-row>
              <a-form-model-item label="变更方式" prop="type">
                <a-radio-group v-model="form.type" name="type">
                  <a-radio value="UPDATE">
                    更新原站点信息
                  </a-radio>
                  <a-radio value="CREATE">
                    新增替换站点信息
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </el-row>
            <el-row>
              <a-form-model-item label="修改原因" prop="reason">
                <a-textarea v-model="form.reason" :rows="3" :max-length="100" placeholder="请输入修改原因" />
              </a-form-model-item>
            </el-row>
          </template>
        </div>
      </block-title>
      <block-title
        title="提交人信息"
        class="author"
        :show-line="false"
      >
        <template v-if="isChange">
          <div class="flex change-info">
            <div>
              <p class="info-title">提交人信息</p>
              <p class="info-value">
                {{ authInfo }}
                <a-icon class="eye-icon" :type="showAuth ? 'eye-invisible' : 'eye'" @click="changeShowAuth" />
              </p>
            </div>
            <div>
              <p class="info-title">提交审核时间</p>
              <p class="info-value">
                {{editRow.createTime}}
              </p>
            </div>
          </div>
          <div class="flex change-info">
            <div>
              <p class="info-title">审核状态</p>
              <div class="info-value">
                <div :class="`dot ${editRow.flowStatus}`" />
                {{FLOWSTATUS[editRow.flowStatus]}}
              </div>
            </div>
            <div>
              <p class="info-title">审核备注</p>
              <div class="info-remark">
                <p>{{editRow.applyContent}} </p>
                <p v-if="editRow.applyContent">{{editRow.updateTime}}</p>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <el-row>
            <el-col :span="11">
              <a-form-model-item label="提交人姓名" prop="updateUserName">
                <a-input v-model="form.updateUserName" :max-length="10" placeholder="请输入提交人姓名" />
              </a-form-model-item>
            </el-col>
            <el-col :span="11" :offset="2">
              <a-form-model-item label="提交人手机号" prop="phone">
                <a-input v-model="form.phone" :max-length="11" placeholder="请输入提交人手机号" />
              </a-form-model-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <a-form-model-item label="短信验证码" prop="verificationCode">
                <a-input v-model="form.verificationCode" :max-length="10" placeholder="请输入验证码">
                  <a-button
                    slot="suffix"
                    :class="AuthCodeText === codeNomal ? '' : 'is-send'"
                    :disabled="(!form.phone || !(/^[1][0-9]{10}$/.test(form.phone)) || codeNomal !== AuthCodeText)"
                    type="link"
                    @click="getAuthCode"
                  >
                    {{AuthCodeText}}
                  </a-button>
                </a-input>
              </a-form-model-item>
            </el-col>
          </el-row>
        </template>
      </block-title>
    </a-form-model>
    <div class="drawer-bottom">
      <a-button @click="onClose">取消</a-button>
      <a-button :loading="submitLoading" type="primary" class="submit-btn" @click="onSubmit">确定</a-button>
    </div>
  </a-drawer>
</template>

<script>
import loadingMixin from "@thales/loading";
import BlockTitle from '@/components/panel/BlockTitle.vue'
import moment from 'moment';
import { getPoiList, updateAddress, getAddressDetail, sendCode } from '../../api'
import { FLOWSTATUS, CHANGETYPE } from '../tableColums'

export default {
  name: 'EditAddress',
  components: {
    BlockTitle
  },
  mixins: [loadingMixin],
  data() {
    return {
      visible: false,
      editRow: {},
      FLOWSTATUS,
      CHANGETYPE,
      poiList: [],
      loading: {
        onPoiSearch: false,
      },
      submitLoading: false,
      form: {
        type: 'CREATE',
        orderNo: '',
        stationContact: '',
        stationContactPhone: '',
      },
      isChange: false,
      showAuth: false,
      AuthCodeText: '获取验证码',
      codeNomal: '获取验证码',
      rules: {
        allAdress: [{required: true, message: '请输入变更后地址信息', trigger: 'change'}],
        stationContact: [{required: true, message: '请输入联系人姓名', trigger: 'change'}],
        stationContactPhone: [
          {required: true, message: '请输入联系人手机号', trigger: 'change'},
          { pattern: /^\d{1,12}$/, message: '请输入正确的手机号', trigger: 'blur' },
        ],
        reason: [{required: true, message: '请输入修改原因', trigger: 'change'}],
        updateUserName: [{required: true, message: '请输入提交人姓名', trigger: 'change'}],
        phone: [
          {required: true, message: '请输入提交人手机号', trigger: 'change'},
          { pattern: /^[1][0-9]{10}$/, message: '请输入正确的手机号', trigger: 'blur' },
        ],
        verificationCode: [{required: true, message: '请输入验证码', trigger: 'change'}],
      },
    }
  },
  computed: {
    authInfo() {
      const {updateUserName = '',phone = ''} = this.editRow
      if (!this.showAuth) {
        return `${`${updateUserName.slice(0, 1)}**`} ${`${phone.slice(0,3)}****${phone.slice(7)}`}`
      }
      return `${updateUserName} ${phone}`
    }
  },
  methods: {
    async onShow(row) {
      this.visible = true
      this.editRow = {
        ...row,
        originalProvinceName: row.provinceName,
        originalCityName: row.cityName,
        originalCountyName: row.countryName,
        originalStationAddress: row.stationAddress,
        originalStationContact: row.contactName,
        originalStationContactPhone: row.contactPhone,
      }
      if (row.upAddType === 1) {
        this.isChange = true
        const res = await getAddressDetail({
          odrNo: row.odrNo
        })
        this.editRow = {
          ...this.editRow,
          ...res,
          createTime: moment(res.createTime).format('YYYY-MM-DD HH:mm:ss'),
          updateTime: moment(res.updateTime).format('YYYY-MM-DD HH:mm:ss'),
        }
      } else {
        this.form.orderNo = row.odrNo
        this.form.stationContact = row.contactName
        this.form.stationContactPhone = row.contactPhone
        const { userId, realName } = this.$store.state.user
        this.form.operatorId = userId
        this.form.operatorName = realName
      }
    },
    onClose() {
      this.$refs.addressForm.clearValidate()
      this.form = {}
      this.showAuth = false
      this.visible = false
    },
    onSubmit() {
      if (this.isChange) {
        this.onClose()
        return
      }
      this.$refs.addressForm.validate(async(valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            await updateAddress(this.form)
            this.$message.success('提交成功')
            this.onClose()
          } catch(err) {
            this.submitLoading = false
          }
          this.$emit('success')
        }
      })
    },
    async onPoiSearch(val) {
      if (val) {
        this.poiList = await getPoiList({
          address: val
        })
      }
    },
    handlePoiChange(value) {
      const current = this.poiList.find(item => item.id === value) || {}
      this.form.provinceName = current.province
      this.form.cityName = current.city
      this.form.countyName = current.county
      this.form.address = current.origAddress
      this.form.allAdress = `${current.province||''}${current.city||''}${current.county||''}${current.origAddress ||''}`
      this.form.provinceCode = current.provinceCode
      this.form.cityCode = current.cityCode
      this.form.countyCode = current.countyCode
    },
    changeShowAuth() {
      this.showAuth = !this.showAuth
    },
    async getAuthCode() {
      let count = 60
      let isdistimer = null
      await sendCode({
        phone: this.form.phone
      })
      this.$message.success('验证码发送成功')
      isdistimer = setInterval(() => {
        if (count > 0) {
          count -= 1
          this.AuthCodeText = `重新获取${count}S`
        } else {
          count = 60
          this.AuthCodeText = this.codeNomal
          clearInterval(isdistimer)
        }
      }, 1000)
    },
  }
}
</script>

<style lang="less" scoped>
.edit-address {
  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
    display: inline-block;
  }
  .FAIL {
    background: #F53F3F;
  }
  .TO_BE_APPROVAL {
    background: #FF7D00;
  }
  .REJECTED {
    background: #F53F3F;
  }
  .APPROVAL {
    background: #00B42A;
  }
  .APPROVAL_TERMINATION {
    background: #7E8694;
  }
  .status {
    color: #1C2026;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }
  ::v-deep .ant-drawer-wrapper-body {
    .ant-drawer-body {
      padding-top: 0;
      height: calc(100% - 122px);
      overflow-y: auto;
    }
    .ant-drawer-header {
      padding: 20px 24px;
    }
    .ant-form-item-label {
      line-height: 22px;
      margin-bottom: 8px;
    }
  }
  .address-alert {
    background: #FFF2E5;
    ::v-deep .ant-alert-icon {
      color: #FF7D00;
    }
    ::v-deep .ant-alert-message {
      color: #FF7D00;
    }
  }
  .order-no {
    margin: 24px 0;
    font-weight: 500;
    font-size: 20px;
  }
  .info-block {
    padding: 16px;
    margin-top: 16px;
    border: 1px solid #F0F2F5;
    border-radius: 4px;
    background: #FAFBFC;
    .change-title {
      padding: 5px 12px;
      border-radius: 2px;
      display: inline-block;
      margin-bottom: 16px;
    }
    .change-before {
      border: 1px solid #CDD2DA;
      color: #505762;
      background: #E6EAF0;
    }
    .change-after {
      border: 1px solid #CDF1E6;
      color: #06B880;
      background: #E6F8F2;
    }
  }

  .change-info {
    font-size: 14px;
    line-height: 22px;
    > div {
      flex: 1;
      margin-right: 16px;
      .info-title {
        color: #7E8694;
      }
      .info-value {
        margin-top: 4px;
        color: #1C2026;
        display: flex;
        align-items: center;
        .eye-icon {
          margin-left: 10px;
          cursor: pointer;
        }
      }
      .info-remark {
        margin-top: 4px;
        color: #1C2026;
      }
    }
  }
  .author {
    margin-top: 32px;
    padding-top: 32px;
    border-top: 1px solid #E6EAF0;
    ::v-deep .label {
      margin-bottom: 16px;
    }
    ::v-deep .ant-btn-link:not(:disabled) {
      color: #1C2026;
      &:hover {
        color: #06B880;
      }
      &:active {
        color: #059366;
      }
    }
    .is-send {
      color: #B4EAD9 !important;
    }
  }
  .drawer-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 56px;
    background: #fff;
    width: 100%;
    z-index: 99;
    padding: 0 24px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-top: 1px solid #EBEDF0;
    .submit-btn {
      margin-left: 12px;
    }
  }
}
</style>